<template>
    <div v-if="shouldRender">
        <div v-if="!loading & !selecting">
            <vue-plotly :data="data" :layout="layout" :options="options" ref="plotly"/>
            <vue-plotly :data="data2" :layout="layout2" :options="options"/>
            <vue-plotly :data="data3" :layout="layout3" :options="options"/>
        </div>
        <div v-else>
            <loading-progress-bar :loading="loading" v-if="!selecting"></loading-progress-bar>
        </div>
    </div>
</template>

<script>
  import VuePlotly from '@/components/VuePlotly'
  import {getAnomalies, getTimeSeries, getDateTime} from '@/helper'
  import {subDays, addDays, compareAsc} from 'date-fns'
  import _ from 'lodash'
  import LoadingProgressBar from '../LoadingProgressBar'

  export default {
    name: 'AnomalyScatterPlot',
    components: { LoadingProgressBar, VuePlotly },
    data () {
      return {
        data: [],
        data2: [],
        layout2:{},
        data3: [],
        layout3: {},
        options: {},
        loading: true,
        selecting: true,
          shouldRender:false,
      }
    },
    props: {
      equipmentName: {type: String, default: null},
      facilityName: {type: String, default: null},
      selectedTime: {type: String, default: null},
      variableX: {type: String, default: null},
      variableY: {type: String, default: null},
      //anomalyName: {type: String, default: null} ,
      //dateRange: {type: Object, default: null}
    },
    watch: {
      equipmentName () {
        this.selecting = true
       // this.refresh()
      },
      facilityName () {
        this.selecting = true
        //this.refresh()
      },
      selectedTime () {
        this.selecting = true
        //this.refresh()
      },
      variableX () {
        //this.refresh()
      },
      variableY () {
        //this.refresh()
      },

    },
    computed: {
      dateRange () {
        return {
          start: getDateTime(subDays(this.selectedTime, 20)),
          end: getDateTime(addDays(this.selectedTime, 20))
        }
      },
      layout () {
        return {
          autosize: true,
          hovermode: 'closest',
          yaxis: {
            title: this.variableY
          },
          xaxis: {
            title: this.variableX
          },
          title: {text: ''}
        }
      } ,

    },
    mounted() {
      this.refresh()
    },
    methods: {

      refresh: _.debounce(
            function run() {
              this.refreshFunc()
            },
            800),

      async refreshFunc() {
        this.shouldRender=this.variableX&&this.variableY&&this.variableX!=this.variableY
          if(!this.shouldRender){
              return
          }
        this.selecting = false
        this.loading = true
        let dfData = await getTimeSeries(
          [this.variableX, this.variableY],
          this.equipmentName,
          this.facilityName,
          this.dateRange,
          null,
          true // on only
        )
        let anomalyName = this.variableX + '__' + this.variableY

        let dfAnomaly = await getAnomalies(
          this.equipmentName,
          this.facilityName,
          this.dateRange,
          anomalyName
        )

        if (dfAnomaly['timestamp'].length<1){
          // if no result try Y__X instead of X__Y
          anomalyName = this.variableY + '__' + this.variableX
          dfAnomaly = await getAnomalies(
            this.equipmentName,
            this.facilityName,
            this.dateRange,
            anomalyName
          )
        }
          let colorscaleValue = [
              [0, process.env.VUE_APP_THEME=='dark' ? "rgb(31, 119, 180)" : '#0000FF'],
              [1, process.env.VUE_APP_THEME=='dark' ? "rgb(214, 39, 40)" : '#FF0000']
          ]
          let x = []
          let y = []
          let c = []
          let text = []
          let mainPoint=null
          for (let i in dfData['timestamp']){
              let ts=dfData['timestamp'][i]
              let aIndex=dfAnomaly['timestamp'].indexOf(ts)
              if(aIndex>-1){
                  if (compareAsc(this.selectedTime,ts)==0){
                      mainPoint={
                          x:[dfData[this.variableX][i]],
                          y:[dfData[this.variableY][i]],
                          ts:[ts],
                          text:[ts+':'+dfAnomaly.value[aIndex]],
                          name:this.selectedTime,
                          marker: {
                              size: 20,
                              colorscale: colorscaleValue,
                              cmin:0,
                              cmax:1,
                              color:[dfAnomaly.value[aIndex]],
                              line: {
                                  color: 'rgb(44, 160, 44)',
                                  width: 4
                              }
                          }
                      }
                  } else {
                      x.push(dfData[this.variableX][i])
                      y.push(dfData[this.variableY][i])
                      c.push(dfAnomaly.value[aIndex])
                      text.push(ts+':'+dfAnomaly.value[aIndex])
                  }

              }
          }
          this.data = [
              {
                  x: x,
                  y: y,
                  mode: 'markers',
                  text: text,
                  name: "Other Readings",
                  marker: {
                      size:12,
                      colorscale: colorscaleValue,
                      cmin:0,
                      cmax:1,
                      color: c,
                  }
              },
              mainPoint,
        ]
          this.data2 = [
              {
                  x: dfData['timestamp'],
                  y: dfData[this.variableX],
                  mode:"line",
                  marker: {
                      size:2,
                      colorscale: colorscaleValue,
                      cmin:0,
                      cmax:1,
                      color: c,
                  }
              }
          ]
          let cleaned=mainPoint.x[0] ? mainPoint.x[0].toFixed(2) : mainPoint.x[0]
          this.layout2={
            title:this.variableX,
              xaxis: {title:"Time "},
              yaxis: {title:this.variableX},
              annotations: [
                  {
                      x: mainPoint.ts[0],
                      y: mainPoint.x[0],
                      xref: 'x',
                      yref: 'y',
                      text: this.selectedTime+ ' : '+cleaned,
                      showarrow: true,
                      arrowhead: 6,
                      borderwidth: 2,
                      borderpad: 2,
                      bordercolor:"rgb(44, 160, 44)",
                      arrowcolor:"rgb(44, 160, 44)",
                      ax: 0,
                      ay: -40
                  }
              ]
          }
          this.data3 = [
              {
                  x: dfData['timestamp'],
                  y: dfData[this.variableY],
              }
          ]
          let cleaned2=mainPoint.y[0] ? mainPoint.y[0].toFixed(2) : mainPoint.y[0]
          this.layout3={
              title:this.variableY,
              xaxis: {title:"Time "},
              yaxis: {title:this.variableY},
              annotations: [
                  {
                      x: mainPoint.ts[0],
                      y: mainPoint.y[0],
                      xref: 'x',
                      yref: 'y',
                      text: this.selectedTime+ ' : '+cleaned2,
                      showarrow: true,
                      arrowhead: 6,
                      borderwidth: 2,
                      borderpad: 2,
                      bordercolor:"rgb(44, 160, 44)",
                      arrowcolor:"rgb(44, 160, 44)",
                      ax: 0,
                      ay: -40
                  }
              ]
          }
        this.loading = false
        //dfData
        //dfAnomaly
      }
    }
  }
</script>

<style scoped>

</style>
